import { some } from "lodash-es";
export function needConvertStyle(uc, mixedStyle, ctx) {
  return some(mixedStyle, (v, selector) => some(v, (v, pseudo) => uc.hooks.beforeConvertStyle.call(v, {
    ...ctx,
    selector,
    pseudo
  })));
}
export function convertStyle(uc, styleObj, ctx) {
  const needConvert = uc.hooks.beforeConvertStyle.call(styleObj, ctx);
  if (!needConvert) return styleObj;
  const convertResult = uc.hooks.convertStyle.call(styleObj, ctx);
  return convertResult;
}
//# sourceMappingURL=styleConvertPlugin.js.map
